import { useRef as c, useMemo as i } from "react";
const d = (r, s) => {
  const t = c(s);
  return i(() => {
    var e;
    return typeof r == "string" ? { "data-size": ((e = t.current) == null ? void 0 : e[r]) || r } : Object.entries(r).reduce(
      (n, [f, u]) => {
        var o;
        return n[`data-size-${f}`] = ((o = t.current) == null ? void 0 : o[u]) || u, n;
      },
      {}
    );
  }, [r]);
};
export {
  d as useSizeAttrs
};
